<template>
  <b-input-group>
    <b-form-input
      :value="inputValue"
      @update="handleChange"
      @blur="handleBlur"
      :type="type"
      :state="validationState"
      :disabled="disabled"
      :placeholder="`${placeholder}${rules?.includes('required') ? '*' : ''}`"
      :trim="trim"
      :lazy
      masked="false"
    />
    <slot></slot>
    <b-form-invalid-feedback v-if="errorMessage">
      {{ errorMessage }}
    </b-form-invalid-feedback>
  </b-input-group>
</template>

<script lang="ts" setup>
import { useField } from 'vee-validate'
import { toRef, withDefaults, onUnmounted, onMounted, computed } from 'vue'
import type { FormInputType } from '@/types'

const props = withDefaults(
  defineProps<{
    placeholder?: string
    type?: FormInputType
    name: string
    disabled?: boolean
    modelValue?: any
    clearOnDestroy?: boolean
    rules?: string
    label?: string
    validateOnMount?: boolean
    trim?: boolean
    lazy?: boolean
  }>(),
  {
    type: 'text',
    validateOnMount: true,
    trim: true,
    lazy: true
  }
)

const nameRef = toRef(props, 'name')
const rulesRef = toRef(props, 'rules')

const {
  value: inputValue,
  errorMessage,
  handleBlur,
  handleChange,
  meta
} = useField(nameRef, rulesRef, {
  initialValue: props.modelValue,
  label: props.label || props.name,
  validateOnMount: props.validateOnMount
})

onMounted(() => {
  if (inputValue.value && props.validateOnMount) handleBlur()
})

onUnmounted(() => {
  if (props.clearOnDestroy) {
    inputValue.value = null
  }
})

const validationState = computed(() => {
  if (!((meta.touched || meta.dirty) && meta.validated)) return null
  return meta.valid
})
</script>
